export default {
  AddNew: 1,
  Update: 2,
  OverWrite: 3
};
